import { useCallback, useState, useEffect } from "react";
import { MailingsBulkCreationService } from "../../../services/mailingsBulkCreation";

export const useFetchDynamicFields = () => {
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const [data, setData] = useState<any[]>([]);

  const fetchData = useCallback(async () => {
    try {
      const res = await MailingsBulkCreationService.dynamicFields();

      setData(res);

      setIsLoading(false);
    } catch (e: any) {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { isLoading, data };
};
